// extracted by mini-css-extract-plugin
export var anchor = "_4v-0";
export var discard = "_4v-4";
export var muiTooltipTooltip = "_4v-6";
export var notificationBar = "_4v-3";
export var saveButtonHoverSlotWrapper = "_4v-5";
export var show = "_4v-2";
export var spacer = "_4v-1";